import styled from 'styled-components'

export const PageContainer = styled.div`
  height: calc(100vh - ${({ theme }) => theme.layout.appHeaderHeight});
  position: fixed;
  top: ${({ theme }) => theme.layout.appHeaderHeight};
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  overflow: hidden;
`

export const MainContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;

  @media (max-width: 1024px) {
    /* Ensure content takes full width on mobile */
    flex-direction: column;
  }
`

export const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`

export const MainContent = styled.main`
  flex: 1;
  height: 100%;
  overflow-y: auto;
  background: white;
  position: relative;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const MapWrapper = styled.div<{ $isOpen?: boolean; $width?: number }>`
  width: ${(props) => (props.$width ? `${props.$width}px` : '580px')};
  min-width: 320px;
  max-width: 90vw;
  height: 100%;
  background: #f5f5f5;
  border-left: 1px solid #e5e5e5;
  position: relative;
  flex-shrink: 0;
  transition: ${(props) => (props.$width ? 'none' : 'transform 0.3s ease')};

  @media (max-width: 1200px) {
    position: fixed;
    top: ${({ theme }) => theme.layout.appHeaderHeight};
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    z-index: 1000;
    transform: translateX(${(props) => (props.$isOpen ? '0' : '100%')});
    transition: transform 0.3s ease;
  }
`

export const MapCloseButton = styled.button`
  display: none;

  @media (max-width: 1200px) {
    display: flex;
    position: absolute;
    top: 16px;
    right: 16px;
    width: 40px;
    height: 40px;
    background: white;
    border: none;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: all 0.2s;

    &:hover {
      background: #f5f5f5;
      transform: scale(1.05);
    }

    &:active {
      transform: scale(0.95);
    }
  }
`

export const MobileMapToggle = styled.button`
  display: none;
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 56px;
  height: 56px;
  background: #00ade6;
  color: white;
  border-radius: 50%;
  border: none;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 999;
  align-items: center;
  justify-content: center;

  @media (max-width: 1200px) {
    display: flex;
  }

  svg {
    width: 24px;
    height: 24px;
  }
`
